/**
 * CSP Product Page Info - Carousel Synchronization
 *
 * NOTE:
 * The carousel is intentionally independent from variant selection.
 * This script handles cart drawer opening and variant price updates.
 */

(function () {
  "use strict";

  function initCspProductPageInfo() {
    // Format money helper using Intl.NumberFormat for proper localization
    function formatMoney(cents, currencyCode = 'EUR', locale = 'fr-FR') {
      const amount = cents / 100;
      
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (error) {
        // Fallback to manual formatting if Intl fails
        const formattedAmount = amount.toFixed(2).replace('.', ',');
        
        // European languages: currency after, others: currency before
        const symbolAfterLangs = ['fr', 'es', 'it', 'de', 'nl', 'pt', 'sv', 'da', 'no', 'fi', 'pl', 'cs', 'hu', 'ro'];
        const lang = locale.split('-')[0];
        const currencySymbol = getCurrencySymbol(currencyCode);
        
        if (symbolAfterLangs.includes(lang)) {
          return formattedAmount + ' ' + currencySymbol;
        } else {
          return currencySymbol + formattedAmount;
        }
      }
    }
    
    // Helper to get currency symbol
    function getCurrencySymbol(currencyCode) {
      const symbols = {
        'EUR': '€',
        'USD': '$',
        'GBP': '£',
        'JPY': '¥',
        'CHF': 'CHF',
        'CAD': '$',
        'AUD': '$'
      };
      return symbols[currencyCode] || currencyCode;
    }

    // Update price in add to cart button when variant changes
    function updateVariantPrice() {
      const form = document.querySelector('[data-type="add-to-cart-form"]');
      if (!form) return;

      const variantIdInput = form.querySelector('input[name="id"]');
      if (!variantIdInput) return;

      const variantId = variantIdInput.value;
      if (!variantId) return;

      // Get variant prices from data attribute
      const productForm = form.closest('product-form-component');
      if (!productForm) return;

      const variantPricesJson = productForm.dataset.variantPrices;
      if (!variantPricesJson) return;

      try {
        const variantPrices = JSON.parse(variantPricesJson);
        const priceData = variantPrices[variantId];

        if (priceData) {
          const priceElement = document.querySelector('[data-variant-price]');
          if (priceElement) {
            const price = priceData.price;
            const compareAtPrice = priceData.compare_at_price;
            
            // Get currency code and locale from data attributes
            const currencyCode = priceElement.dataset.currencyCode || 'EUR';
            const localeCode = priceElement.dataset.locale || 'fr';
            const locale = localeCode + '-' + currencyCode.slice(0, 2); // e.g., 'fr-FR', 'en-US'

            // Check if there's a sale (compare_at_price exists and is greater than price)
            if (compareAtPrice && compareAtPrice > price) {
              priceElement.innerHTML = '<span class="add-to-cart-text__price-sale">' + formatMoney(price, currencyCode, locale) + '</span>' +
                                       '<span class="add-to-cart-text__price-original">' + formatMoney(compareAtPrice, currencyCode, locale) + '</span>';
            } else {
              priceElement.textContent = formatMoney(price, currencyCode, locale);
            }
          }
        }
      } catch (error) {
        console.error('Error parsing variant prices', error);
      }
    }

    // Listen for variant changes - use input event for immediate response
    const form = document.querySelector('[data-type="add-to-cart-form"]');
    if (form) {
      const variantIdInput = form.querySelector('input[name="id"]');
      if (variantIdInput) {
        // Listen to both change and input events
        variantIdInput.addEventListener('change', updateVariantPrice);
        variantIdInput.addEventListener('input', updateVariantPrice);

        // Also observe attribute changes (for programmatic updates)
        const observer = new MutationObserver(updateVariantPrice);
        observer.observe(variantIdInput, {
          attributes: true,
          attributeFilter: ['value']
        });
      }
    }

    // Open cart drawer after successful add to cart
    /** @param {CustomEvent} event */
    function handleCartAdd(event) {
      // Check if this is a successful cart add (not an error)
      const didError = event.detail?.data?.didError;
      if (didError) {
        return; // Don't open on error
      }

      // Only open if the event came from our product forms
      const sourceId = event.detail?.sourceId;
      const source = event.detail?.data?.source;

      // Check if it's from our CSP product forms or any product form
      const isFromOurForm =
        sourceId &&
        (sourceId.includes("csp-product-form") ||
          sourceId.includes("BuyButtons") ||
          source === "product-form-component");

      if (!isFromOurForm) {
        return;
      }

      // Find and open the cart drawer
      /** @type {any} */
      const cartDrawer = document.querySelector("cart-drawer-component");
      if (cartDrawer && typeof cartDrawer.open === "function") {
        // Small delay to ensure cart content is updated
        setTimeout(() => {
          cartDrawer.open();
        }, 100);
      }
    }

    // Listen for cart update events (CartAddEvent uses 'cart:update' as event name)
    document.addEventListener("cart:update", handleCartAdd, { passive: true });
  }

  // Initialize
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCspProductPageInfo);
  } else {
    initCspProductPageInfo();
  }
})();
